// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createPopoverContent_root__3mO-O {\n  padding: 10px 12px;\n  box-sizing: border-box; }\n", ""]);
// Exports
exports.locals = {
	"root": "createPopoverContent_root__3mO-O"
};
module.exports = exports;
